(function () {
  if (location.pathname.replace(/\/$/, "") === "/collections/moving-head-bar-lights") {
    document.documentElement.classList.add("la-legacy-lighting-redirect");
    location.replace("/collections/pixel-matrix-creative-effects");
    return;
  }

  var menuItems = [
    ["BSW / Spot / Profile / Studio", "/collections/3in1-bsw-hybrid-moving-light"],
    ["Beam / Pattern Moving Head", "/collections/moving-head-beam-lights"],
    ["Wash / Bee Eye Moving Head", "/collections/moving-head-wash-light"],
    ["Matrix / Pixel Bar / Wall Washer", "/collections/pixel-matrix-creative-effects"],
    ["Strobe / Blinder", "/collections/strobe-blinder-retro-lights"],
    ["Retro Effects", "/collections/retro-stage-lighting"],
    ["PAR / Face / Waterproof PAR", "/collections/par-studio-audience-lights"],
    ["Laser Light", "/collections/laser-lights"],
    ["Control / DMX", "/collections/dmx-controller"],
    ["Special Effects", "/collections/special-effects-products"]
  ];
  var handles = [
    "moving-head-beam-lights",
    "3in1-bsw-hybrid-moving-light",
    "spot-moving-light",
    "moving-head-wash-light",
    "moving-head-bar-lights",
    "pixel-matrix-creative-effects",
    "par-light",
    "retro-stage-lighting",
    "strobe-wash-effect-light",
    "waterproof-light",
    "laser-light",
    "dmx-controller",
    "special-effects-products"
  ];
  var retroHandles = null;
  var retroRequestStarted = false;

  function handle(link) {
    try {
      var match = new URL(link.getAttribute("href") || "", location.origin).pathname.match(/^\/collections\/([^/]+)\/?$/);
      return match ? match[1] : "";
    } catch (error) {
      return "";
    }
  }

  function normalize(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function itemLabel(item) {
    var control = item.querySelector(":scope > a, :scope > button, :scope > summary, :scope > details > summary");
    var clone = (control || item).cloneNode(true);
    clone.querySelectorAll(".dropdown-menu, .mega-menu, x-popover, svg, style, script").forEach(function (node) {
      node.remove();
    });
    return normalize(clone.textContent);
  }

  function homeItem(sourceItem) {
    var li = document.createElement("li");
    var link = document.createElement("a");
    var sourceControl = sourceItem ? sourceItem.querySelector("a,summary") : null;
    li.className = "la-header-home-item";
    link.href = "/";
    link.className = sourceControl ? sourceControl.className : "bold link-faded-reverse";
    link.classList.add("la-header-home-link");
    link.textContent = "Home";
    li.appendChild(link);
    return li;
  }

  function hide(link) {
    var target = link.closest("li") || link;
    target.classList.add("la-header-temp-hidden");
    target.setAttribute("aria-hidden", "true");
  }

  function splitRetroCategory() {
    if (location.pathname.replace(/\/$/, "") !== "/collections/all-stage-lighting") return;
    if (!retroHandles) {
      if (retroRequestStarted) return;
      retroRequestStarted = true;
      fetch("/collections/retro-stage-lighting/products.json?limit=250", { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("retro products unavailable");
          return response.json();
        })
        .then(function (payload) {
          retroHandles = new Set((payload.products || []).map(function (product) { return product.handle; }).filter(Boolean));
          splitRetroCategory();
        })
        .catch(function () { retroHandles = new Set(); });
      return;
    }
    var strobe = document.querySelector("#la-series-strobe-effect");
    if (!strobe || document.querySelector("#la-series-retro-effects")) return;

    var grid = strobe.querySelector(".la-series-group-grid");
    if (!grid) return;
    var cards = Array.from(document.querySelectorAll(".shopify-section--main-collection .la-series-product-card"));
    var retroCards = cards.filter(function (card) {
      var productHandle = card.dataset.productHandle || (card.getAttribute("href") || "").split("/products/")[1] || "";
      return retroHandles.has(decodeURIComponent(productHandle.split(/[?#/]/)[0]));
    });
    if (!retroCards.length) return;

    var section = document.createElement("section");
    section.className = "la-series-group-section";
    section.id = "la-series-retro-effects";
    section.dataset.group = "retro-effects";
    section.innerHTML = '<div class="la-series-group-heading"><div><h2 class="la-series-group-title">Retro Effects</h2><p class="la-series-group-note">Decorative retro, tungsten-look and kinetic effect fixtures grouped as a dedicated visual family.</p></div><div class="la-series-group-count">' + retroCards.length + (retroCards.length === 1 ? " product" : " products") + '</div></div><div class="la-series-group-grid"></div>';
    var retroGrid = section.querySelector(".la-series-group-grid");
    retroCards.forEach(function (card) { retroGrid.appendChild(card); });
    strobe.after(section);

    var strobeTitle = strobe.querySelector(".la-series-group-title");
    var strobeNote = strobe.querySelector(".la-series-group-note");
    var strobeCount = strobe.querySelector(".la-series-group-count");
    if (strobeTitle) strobeTitle.textContent = "Strobe / Blinder";
    if (strobeNote) strobeNote.textContent = "High-impact strobe and audience blinder fixtures for rhythmic accents, flashes and crowd illumination.";
    if (strobeCount) {
      var remaining = grid.querySelectorAll(".la-series-product-card").length;
      strobeCount.textContent = remaining + (remaining === 1 ? " product" : " products");
    }
  }

  function systemDropdown(root, summarySelector) {
    var summary = root.querySelector(summarySelector);
    var details = summary && summary.closest("details");
    return details && details.querySelector(":scope > .dropdown-menu");
  }

  function styleSystemDropdown(menu, options) {
    menu.style.setProperty("--text-color", "244, 244, 244", "important");
    menu.style.setProperty("color", "#f4f4f4", "important");
    menu.style.setProperty("background", "#0b0d10", "important");
    menu.style.setProperty("border-color", "rgba(212, 168, 91, 0.34)", "important");
    menu.style.setProperty("box-shadow", "0 26px 70px rgba(0, 0, 0, 0.42)", "important");

    var viewAll = Array.from(menu.querySelectorAll('a[href="' + options.viewAllHref + '"]')).find(function (link) {
      return normalize(link.textContent) === options.viewAllLabel;
    });
    if (viewAll && viewAll.closest("li")) {
      viewAll.closest("li").classList.add("la-system-view-all", options.viewAllClass);
    }

    Array.from(menu.querySelectorAll("a.dropdown-menu__item")).forEach(function (link) {
      link.style.setProperty("color", "#f4f4f4", "important");
      link.style.setProperty("opacity", "1", "important");
      link.style.setProperty("background", "#14171c", "important");
      link.style.setProperty("border-color", "rgba(255, 255, 255, 0.09)", "important");
    });
    if (viewAll) {
      viewAll.style.setProperty("color", "#d4a85b", "important");
      viewAll.style.setProperty("background", "#090b0e", "important");
      viewAll.style.setProperty("border-color", "rgba(212, 168, 91, 0.38)", "important");
    }
  }

  function sync(root) {
    var links = Array.from(root.querySelectorAll("a[href]"));
    var categories = links.filter(function (link) {
      return link.dataset.laLightingMenuItem === "1" || handles.indexOf(handle(link)) !== -1;
    });
    if (!categories.length) return;

    categories.forEach(function (link, index) {
      if (index >= menuItems.length) {
        hide(link);
        return;
      }
      if (link.getAttribute("href") !== menuItems[index][1]) link.href = menuItems[index][1];
      if ((link.textContent || "").trim() !== menuItems[index][0]) link.textContent = menuItems[index][0];
      link.dataset.laLightingMenuItem = "1";
      var container = link.closest("li");
      if (container) {
        container.classList.remove("la-header-temp-hidden");
        container.removeAttribute("aria-hidden");
      }
    });

    links.forEach(function (link) {
      if (handle(link) === "all-stage-lighting" && /view all stage lighting/i.test(link.textContent || "")) {
        if (link.getAttribute("href") !== "/collections/all-stage-lighting") link.href = "/collections/all-stage-lighting";
        if ((link.textContent || "").trim() !== "View All Stage Lighting") link.textContent = "View All Stage Lighting";
      }
    });

    if (root.matches && root.matches("header, store-header")) {
      var audioMenu = systemDropdown(root, 'summary[data-url="/collections/all-audio-products"]');
      if (audioMenu) {
        audioMenu.classList.add("la-system-dropdown", "la-audio-systems-dropdown");
        styleSystemDropdown(audioMenu, {
          viewAllHref: "/collections/all-audio-products",
          viewAllLabel: "View All Audio Systems",
          viewAllClass: "la-audio-systems-view-all"
        });
      }

      var stageMenu = systemDropdown(root, 'summary[data-url="/collections/all-stage-lighting"]');
      if (stageMenu) {
        stageMenu.classList.add("la-system-dropdown", "la-stage-lighting-dropdown");
        styleSystemDropdown(stageMenu, {
          viewAllHref: "/collections/all-stage-lighting",
          viewAllLabel: "View All Stage Lighting",
          viewAllClass: "la-stage-lighting-view-all"
        });
      }
    }
  }

  function apply() {
    document.querySelectorAll("header, store-header, header-sidebar, .navigation-drawer").forEach(sync);
    document.querySelectorAll("header .header__link-list > ul, store-header .header__link-list > ul, header-sidebar .panel__wrapper ul, .navigation-drawer ul").forEach(function (list) {
      var items = Array.from(list.children).filter(function (node) {
        return node && node.tagName && node.tagName.toLowerCase() === "li";
      });
      var hasCoreNav = items.some(function (item) {
        return ["Audio Systems", "Stage Lighting", "LED Display"].indexOf(itemLabel(item)) !== -1;
      });
      if (!hasCoreNav) return;
      items.forEach(function (item) {
        var label = itemLabel(item);
        if (label === "Applications" || label === "Solutions") {
          item.classList.add("la-header-temp-hidden");
          item.setAttribute("aria-hidden", "true");
        }
      });
      if (!list.querySelector(".la-header-home-item")) {
        var firstVisible = Array.from(list.children).find(function (item) {
          return item.tagName && item.tagName.toLowerCase() === "li" && !item.classList.contains("la-header-temp-hidden");
        });
        list.insertBefore(homeItem(firstVisible), firstVisible || list.firstChild);
      }
    });
    splitRetroCategory();
  }

  apply();
  document.addEventListener("shopify:section:load", apply);
})();
